import { type Profile } from "oidc-client";

import { type PageInterface } from "./page.interface";
import { pages } from "./pages";

const filterByRole =
    (user: Profile) =>
    (page: PageInterface): boolean => {
        const role = user.role ? user.role : "admin";
        return page.roles == undefined || page.roles.includes(role);
    };

export const filterPagesByRoleRecursive = (user: Profile | null): PageInterface[] => {
    if (user === null) return [];
    return Array.from(pages)
        .map(({ childPages: childs, ...page }) => ({
            ...page,
            childPages: childs !== undefined ? Array.from(childs).filter(filterByRole(user)) : undefined,
        }))
        .filter(filterByRole(user));
};
